import { render } from "./MSmsInbox.vue?vue&type=template&id=532e6a29&scoped=true"
import script from "./MSmsInbox.vue?vue&type=script&lang=js"
export * from "./MSmsInbox.vue?vue&type=script&lang=js"

import "./MSmsInbox.vue?vue&type=style&index=0&id=532e6a29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532e6a29"]])

export default __exports__